// extracted by mini-css-extract-plugin
module.exports = {"box":"Check_box__Ooy1s"};